// Миксин для работы со всеми страницами
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history'
})

import PhoneMaskInput from  "vue-phone-mask-input";
export default {
  data() {
    return {}
  },
  router,
  components: {
    PhoneMaskInput,
    uiBreadcrumbs: () => import('../components/ui/ui-breadcrumbs'),
    uiSelectView: () => import('../components/ui/ui-select-view'),
    uiLabel: () => import('../components/ui/ui-label'),
    'icon-arrow-dropdown': () => import('../components/icon/icon-arrow-dropdown'),
    iconSide: () => import('../components/icon/icon-side'),
    iconHeart: () => import('../components/icon/icon-heart'),
    'ui-switcher': () => import('../components/ui/ui-switcher'),
    'ui-button': () => import('../components/ui/ui-button'),
    'ui-pretty-card': () => import('../components/ui/ui-pretty-card.vue'),
    'ui-help-tooltip': () => import('../components/ui/ui-help-tooltip'),
    'icon-bag': () => import('../components/icon/icon-bag'),
    'icon-click': () => import('../components/icon/icon-click'),
    'layout-popup': () => import('../components/layout/layout-popup'),
    'layout-data-popup': () => import('../components/layout/layout-popup'),
    'layout-sent': () => import('../components/layout/layout-sent'),
    'ui-tabs': () => import('../components/ui/ui-tabs.vue'),
    'quiz-banner': () => import('../components/quiz/banner'),
    'quiz-modal-banner': () => import('../components/quiz/modal-banner'),
    'icon-sleeping': () => import('../components/icon/icon-sleeping')
  },
  mounted() {
    setTimeout(() => {
      const allImagesWithDataSrc = document.querySelectorAll('img[data-src]')
      allImagesWithDataSrc.forEach(image => {
        image.setAttribute('src', image.getAttribute('data-src'))
      })
    }, 1000)
  }
}
